module.exports = __webpack_public_path__ + "static/img/fwfw_dzc.649ec4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fwfw_dzc.png
// module id = cZC/
// module chunks = 1